import {
  CLOSE_MENU,
  OPEN_MENU,
  SET_USER_NAME,
} from './actionTypes';

export const openMenu = dispatch => () => dispatch({ type: OPEN_MENU });
export const closeMenu = dispatch => () => dispatch({ type: CLOSE_MENU });
export const setUserName = dispatch => (payload = '') => dispatch({ payload, type: SET_USER_NAME });
